import React from "react";
import { arrayOf, shape, string } from "prop-types";

import ContactInfo from "src/shared/contact-boxes/components/ContactInfo";

import * as S from "./styled";

const ContactsList = ({ contacts }) => (
  <S.ContactsListStyle>
    <S.ContactsListText>LISTED BY</S.ContactsListText>
    <S.ContactsList>
      {contacts.map(contact => (
        <ContactInfo key={contact.id} contact={contact} />
      ))}
    </S.ContactsList>
  </S.ContactsListStyle>
);

ContactsList.propTypes = {
  contacts: arrayOf(
    shape({
      name: string,
      image: shape({ url: string }),
      industry_professional: shape({ headshot: shape({ url: string }) })
    })
  ).isRequired
};

export default ContactsList;
